import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: { retry: false, retryOnMount: false, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
};

export const queryClientFactory = () => new QueryClient(queryClientConfig);
